import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export function ForcePasswordChange() {
  const { user, loadMe, t } = useApp();
  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  if (!user?.must_change_password) return null;

  const submit = async () => {
    setError("");
    if (newPw.length < 6) return setError("New password must be at least 6 characters.");
    if (newPw !== confirm) return setError("New passwords do not match.");
    setSaving(true);
    try {
      await api.post("/profile/change-password", { current_password: currentPw, new_password: newPw });
      await loadMe();
      toast.success("Password updated. Welcome to MobileZone!");
    } catch (e) {
      setError(apiError(e.response?.data?.detail) || "Could not change password.");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={true}>
      <DialogContent className="max-w-md [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <div className="h-11 w-11 rounded-md bg-primary/10 text-primary flex items-center justify-center mb-2"><KeyRound className="h-5 w-5" /></div>
          <DialogTitle>Set a new password</DialogTitle>
          <DialogDescription>For security, you must change your password before continuing.</DialogDescription>
        </DialogHeader>
        {error && <div className="text-sm text-destructive bg-destructive/10 border border-destructive/20 rounded-md px-3 py-2" data-testid="force-error">{error}</div>}
        <div className="space-y-3 mt-1">
          <div><Label>{t("currentPassword")}</Label><Input type="password" value={currentPw} onChange={(e) => setCurrentPw(e.target.value)} className="mt-1.5" data-testid="force-current-pw" /></div>
          <div><Label>{t("newPassword")}</Label><Input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} className="mt-1.5" data-testid="force-new-pw" /></div>
          <div><Label>{t("confirmPassword")}</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" data-testid="force-confirm-pw" /></div>
          <Button className="w-full" onClick={submit} disabled={saving || !currentPw || !newPw || !confirm} data-testid="force-save-pw">Update Password</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
